import { render, staticRenderFns } from "./navLeft.vue?vue&type=template&id=2bbe7170&scoped=true"
import script from "./navLeft.vue?vue&type=script&lang=js"
export * from "./navLeft.vue?vue&type=script&lang=js"
import style0 from "./navLeft.vue?vue&type=style&index=0&id=2bbe7170&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbe7170",
  null
  
)

export default component.exports